<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col" fxLayout="column" fxLayoutGap="20px">
      <image-slider page="about-us" fxHide.lt-lg no-image-margin="30px"></image-slider>

      <h2>
        Der Zimmerer-Treffpunkt ist die Plattform, auf der Zimmerer sich treffen, austauschen, informieren. Es geht um
        Holz, und um diejenigen, die damit arbeiten: Zimmerinnen und Zimmerer, Azubis, Gesellen und Meister.
      </h2>

      <p>
        Hier geht´s um Zimmerei- und Holzbauthemen. Der Zimmerer-Treffpunkt hat es sich zur Aufgabe gemacht, Zimmerer
        online miteinander zu verbinden, zu informieren und eine Profiplattform für den Austausch untereinander im
        Internet zu bieten.
      </p>

      <p>
        Wir wollen zusammen mit Euch die vielen Vorzüge und fast grenzenlosen Möglichkeiten des Baustoffes Holz
        diskutieren und darstellen. Gemeinsam wollen wir auf die Entwicklungen im Holzbau sowie auf die breitgefächerten
        Fähigkeiten der Zimmerleute hinweisen.
      </p>

      <p>
        Weiterhin wollen wir zeigen wie schön, zukunftsträchtig und chancenreich das Zimmererhandwerk für junge Menschen
        ist. Denn, wir haben den schönsten Beruf der Welt, und wir halten zusammen. Gemeinsam verhelfen wir dem
        Werkstoff Holz zum Durchbruch und leisten damit einen Beitrag für eine bessere Welt.
      </p>

      <p>
        2011 wurde der Treffpunkt als Socialmedia-Community gegründet und ist inzwischen zum bekanntesten und größten
        Zimmerer-Portal auf Facebook geworden. Über 17000 Zimmerer tauschen sich auf Facebook aus: unabhängig von ihrer
        Nationalität, aus allen Innungen und Verbänden, unabhängig von ihrem Alter oder ihrem beruflichen Status.
      </p>

      <p>
        2018 startete der Zimmerer-Treffpunkt auch auf Instagram. Hier wird für den Holzbau und für den Beruf des
        Zimmerers begeistert. Und zu Beginn des Jahres 2020 startet die eigene Webseite, welche die Community und den
        Holzbau weiter voranbringen soll.
      </p>

      <p>
        Für was immer der Zimmerer dieses Portal nutzt, für ihn ist es kostenlos. Die Plattform finanziert sich über
        Kooperationen mit Lieferanten der Branche und über Unternehmen und Organisationen, die den Holzbau bewusst
        fördern wollen.
      </p>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
